/* eslint-disable jsx-a11y/alt-text */
import React from 'react';

const tiposValidacaoCriticaOptions = [
  {
    label: (
      <>
        <p>
          <b>OBRIGATORIEDADE</b>
        </p>
      </>
    ),
    value: `OBRIGATORIEDADE`,
  },
  {
    label: (
      <>
        <p>
          <b>ESTRUTURA</b>
        </p>
      </>
    ),
    value: `ESTRUTURA`,
  },
  {
    label: (
      <>
        <p>
          <b>NEGOCIO</b>
        </p>
      </>
    ),
    value: `NEGOCIO`,
  },
  {
    label: (
      <>
        <p>
          <b>PDF</b>
        </p>
      </>
    ),
    value: `PDF`,
  },
  {
    label: (
      <>
        <p>
          <b>INTEGRIDADE_OPCIONAL</b>
        </p>
      </>
    ),
    value: `INTEGRIDADE_OPCIONAL`,
  },
  {
    label: (
      <>
        <p>
          <b>INTEGRIDADE_ARQUIVO</b>
        </p>
      </>
    ),
    value: `INTEGRIDADE_ARQUIVO`,
  },
  {
    label: (
      <>
        <p>
          <b>NEGOCIO_CUSTOMIZADO</b>
        </p>
      </>
    ),
    value: `NEGOCIO_CUSTOMIZADO`,
  },
];

export default tiposValidacaoCriticaOptions;
